import React from 'react';
import type { PropsWithChildren } from 'react';

import { DeadlyDigitsProductsType } from './themes/deadlydigits';
import { ReckonProductsType, defaultReckonTheme } from './themes/reckon';
import { ThemeDecorator } from './themes/ThemeDecorator';
import { Themes } from './themes/themes';
import { Tenancy } from './themes/types';

type LayoutProps = PropsWithChildren<{
  theme: Tenancy;
  product?: ReckonProductsType | DeadlyDigitsProductsType;
  hideFooter?: boolean;
}>;

export const Layout = ({
  children,
  theme,
  product,
  hideFooter,
}: LayoutProps) => {
  const selectedTheme =
    Themes.find((t) => t.tenant === theme && t.product === product) ||
    Themes.find((t) => t.tenant === theme && t.product === 'default') ||
    defaultReckonTheme;

  return (
    <ThemeDecorator
      title={selectedTheme.title}
      publicFolder={selectedTheme.publicSubFolder}
      backgroundColor={selectedTheme.baseTheme.backgroundColor}
      footerLogo={selectedTheme.productTheme.footerLogo}
      headerLogo={selectedTheme.productTheme.headerLogo}
      textColor={selectedTheme.baseTheme.textColor}
      textLinkColor={selectedTheme.baseTheme.textLinkColor}
      leftBackgroundImage={selectedTheme.productTheme.leftBackgroundImage}
      rightBackgroundImage={selectedTheme.productTheme.rightBackgroundImage}
      footerDescription={selectedTheme.productTheme.footerDescription}
      hideFooter={hideFooter}
    >
      {children}
    </ThemeDecorator>
  );
};
